import React from "react"
import { MdHelpOutline } from "react-icons/md"
import "./Iconos.css"

const IconoAyuda = (props) => {
  return (
    <span
      className={"icono-mp" + (props.background ? " background-ayuda" : "")}
    >
      <MdHelpOutline />
    </span>
  )
}

export default IconoAyuda
